export default __webpack_public_path__ + "static/media/Blog12.12.79c94152.png";